import { Component } from '@angular/core';
import { IonIcon } from '@ionic/angular';
import { addIcons } from 'ionicons';
import { lockClosedOutline } from 'ionicons/icons';

import {
  CompanySelectorMenuComponent,
  HomePageToolbarComponent,
  NtyEmptyStateModule,
  PageComponent,
  UserMenuComponent,
} from '@ninety/mobile/platform/components';

import { OBSERVER_NO_ACCESS_COPY } from './observer-no-access-copy';

@Component({
  selector: 'nty-observer-no-access',
  imports: [
    CompanySelectorMenuComponent,
    HomePageToolbarComponent,
    NtyEmptyStateModule,
    PageComponent,
    UserMenuComponent,
    IonIcon,
  ],
  template: `
    <nty-page [id]="contentId">
      <nty-home-page-toolbar nty-header />

      <nty-empty-state>
        <nty-empty-state-graphic>
          <ion-icon name="lock-closed-outline" />
        </nty-empty-state-graphic>
        <nty-empty-state-title>{{ copy.headline }}</nty-empty-state-title>
        <nty-empty-state-description>{{ copy.body }}</nty-empty-state-description>
      </nty-empty-state>
    </nty-page>
    <nty-company-selector-menu [contentId]="contentId" />
    <nty-user-menu [contentId]="contentId" />
  `,
  styles: `
    nty-empty-state {
      max-width: 480px;
      margin: 0 auto;
      padding: 24px;
    }
  `,
})
export class ObserverNoAccessComponent {
  contentId = 'observer-no-access-content';
  copy = OBSERVER_NO_ACCESS_COPY;

  constructor() {
    addIcons({ lockClosedOutline });
  }
}
